import * as React from 'react';

// components
import Input from '../shared/Input';
import { NavLink } from 'react-router-dom';
import { Button, Alert } from 'reactstrap';

// final form
import { Form, Field } from 'react-final-form';

// networking

import * as axios from 'axios';
import { AxiosError } from 'axios';
import AxiosHelper from 'services/AxiosHelper';
import Spinner from 'components/shared/Spinner';

import createDecorator from 'final-form-focus';
import { handleAxiosErrorWithValidation } from 'util/Misc';

export interface ForgotPasswordState {
	success: boolean;
}

const focusOnErrors = createDecorator();

/**
 * ForgotPassword component
 *
 * React component handling responsible for forgot password page.
 *
 * @class ForgotPassword
 * @extends {React.PureComponent<any, ForgotPasswordState>}
 */
class ForgotPassword extends React.PureComponent<any, ForgotPasswordState> {
	private cancelToken: any = null;

	constructor(props) {
		super(props);

		this.state = { success: false };
	}

	public componentWillUnmount() {
		if (this.cancelToken) {
			this.cancelToken();
		}
	}

	public submit = (formValues: any): Promise<void | Record<string, string>> => {
		if (this.cancelToken) {
			this.cancelToken();
		}

		const url = '/ajax/forgot-password/';

		return AxiosHelper.post(url, formValues, {
			cancelToken: new axios.default.CancelToken((token) => {
				this.cancelToken = token;
			}),
		})
			.then(() => {
				this.setState({ success: true });
			})
			.catch((error: AxiosError) => {
				return handleAxiosErrorWithValidation(error, null);
			})
			.then((promise: any) => {
				this.cancelToken = null;
				return promise;
			});
	};

	public render() {
		return (
			<div className="login-form-wrapper">
				{this.state.success ? (
					<div>
						<h2 className="login-form-heading">Success</h2>
						<p className="login-form-heading">Please check your email to reset your password.</p>
					</div>
				) : (
					<Form
						onSubmit={this.submit}
						subscription={{ submitting: true, submitError: true }}
						decorators={[focusOnErrors]}
						render={({ handleSubmit, submitError, submitting }) => (
							<form onSubmit={handleSubmit} className="login-form">
								<h2 className="login-form-heading">Please enter your username.</h2>
								{submitError ? (
									<div>
										<Alert color="danger">{submitError}</Alert>
									</div>
								) : null}

								<Field
									name="username"
									placeholder="username"
									type="text"
									autoFocus
									className=" login-form__text-input"
									indicateDirty={false}
									component={Input}
								/>

								<div className="login-form__actions ">
									<Button
										type="submit"
										disabled={submitting}
										color="primary"
										className="login-form__action login-form__submit-btn"
									>
										Continue
									</Button>
								</div>

								<div className="login-form__footer form-group">
									<NavLink
										className="login-form__action login-form__link"
										exact
										activeClassName="active"
										to="/login"
									>
										Cancel
									</NavLink>
								</div>
								<div className="login-form__actions form-group">{submitting ? <Spinner /> : null}</div>
							</form>
						)}
					/>
				)}
			</div>
		);
	}
}

export default ForgotPassword;
